export const it = {
  login: {
    title: 'Benvenuto su Slash',
    subTitle: 'Inizia a utilizzare la piattaforma',
    slides: {
      slide1: {
        title: 'Unlock your\nAI potential.',
      },
    },
    loginForm: {
      signIn: 'Accedi',
      signUp: 'Registrati',
      newUser: 'La tua azienda non è ancora registrata?',
    },
  },
};
